import uuid from "uuid";

const uuidUtil = () => uuid.v4();

export default uuidUtil;
